import { Box, makeStyles, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import PaymentSuccessView from "./PaymentSuccessView";

const useSuccessPageStyles = makeStyles((theme) => ({
  errorContainer: {
    margin: "0 auto",
    width: 581,
    height: 489,
    marginTop: 13,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const PaymentSuccess = ({ receipt, payment }) => {
  const classes = useSuccessPageStyles();
  //Load memberInfo to confirm
  // const { data, loading, error } = useGetOne("customers", customerId);
  const history = useHistory();
  if (!history.location?.state?.receipt)
    return (
      <Box className={classes.errorContainer}>
        <Typography>{`Something went wrong ${JSON.stringify(
          history.location
        )}`}</Typography>
      </Box>
    );

  return (
    <Box>
      <PaymentSuccessView receipt={receipt} payment={payment} />
    </Box>
  );
};

export default PaymentSuccess;
